var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.show
    ? _c(
        "w-card",
        [
          _c("w-card-title", [
            _vm._v(_vm._s(_vm.$ct("mollie-terminal-settings"))),
          ]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("mollie-terminal-enabled") },
                        model: {
                          value: _vm.settings.enabled,
                          callback: function ($$v) {
                            _vm.$set(_vm.settings, "enabled", $$v)
                          },
                          expression: "settings.enabled",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.settings.enabled
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-mollie-terminal-select", {
                            attrs: {
                              label: _vm.$ct("default-terminal"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.settings.defaultTerminalId,
                              callback: function ($$v) {
                                _vm.$set(_vm.settings, "defaultTerminalId", $$v)
                              },
                              expression: "settings.defaultTerminalId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.terminals.length > 0
                    ? [
                        _c("w-col", { attrs: { xs: "12" } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$ct("mollie-terminal-bank-types")) +
                              " "
                          ),
                        ]),
                        _vm._l(_vm.terminals, function (terminal) {
                          return _c(
                            "w-col",
                            { key: terminal.ID, attrs: { xs: "12" } },
                            [
                              _c("app-select-bank-type", {
                                attrs: {
                                  value:
                                    _vm.mollieConfig.getBankTypeIdForTerminal(
                                      terminal.ID
                                    ),
                                  "use-ids": "",
                                  fancy: "",
                                  label: terminal.toString(),
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.mollieConfig.setBankTypeIdForTerminal(
                                      terminal.ID,
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { disabled: _vm.saving, icon: "save" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.save")))]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }